function _px_generateRandomId() {
	return `${new Date().getTime()}-${_px_generateRandom(8)}`;
}

function setCookie(name, value, daysToLive) {
	// Encode value in order to escape semicolons, commas, and whitespace
	var cookie = name + '=' + encodeURIComponent(value);
	if (typeof daysToLive === 'number') {
		cookie += '; max-age=' + daysToLive * 24 * 60 * 60;
		document.cookie = cookie;
	}
}

function _px_isAnonymous() {
	const PX_COOKIE = 'apt.uid';
	var cookieParts = _px_getCookie(PX_COOKIE).split('.');
	var anonymous = cookieParts.length != 4 || cookieParts[2] === '0';
	return anonymous;
}

function _px_getRandomInt(min, max) {
	min = Math.ceil(min);
	max = Math.floor(max);
	return Math.floor(Math.random() * (max - min)) + min;
}

function _px_generateRandom(howMany) {
	let random = '';
	for (let i = 0; i < howMany; i++) {
		random += _px_getRandomInt(1, 10);
	}
	return random;
}

function _px_getCookie(cname) {
	var name = cname + '=';
	var decodedCookie = decodeURIComponent(document.cookie);
	var ca = decodedCookie.split(';');
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}
	return '';
}

export function setGainsightCookieForAnonUser() {
	if (_px_isAnonymous()) {
		const id = _px_generateRandomId();
		window.aptrinsic('identify', { id });
		setCookie(PX_ANON_COOKIE, id, PX_ANON_COOKIE_DAYS_TO_LIVE);
	}
}

function buildUserIdentity(user, region, subscriberType) {
	return {
		id: `${user.id}`,
		userId: user.userID,
		email: user.email,
		firstName: user.firstName,
		lastName: user.lastName,
		signUpDate: new Date(user.createdDate).getTime(),
		title: user.title,
		role: user.classification,
		subscriberType,
		countryName: region?.name,
		cultureName: region?.cultureName,
	};
}

export function setGainsightIdentity(
	userAccountDetails,
	region,
	subscriberType,
) {
	const user = userAccountDetails?.user;
	if (user) {
		window.aptrinsic(
			'identify',
			buildUserIdentity(user, region, subscriberType),
			{
				id: user.orgID,
				name: user.orgName,
			},
		);
	}
}

export const PX_ANON_COOKIE = 'apt.anon';
export const PX_ANON_COOKIE_DAYS_TO_LIVE = 7;
